import {
    Alert,
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Upload
} from "antd";
import {DownloadOutlined, ExclamationCircleOutlined, PlusOutlined} from "@ant-design/icons";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import {useEffect, useState} from "react";
import {AddressDto} from "../../dto/AddressDto";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES,
    ALLOWED_IMAGE_TYPES_TEXT,
    COMMON_DROPDOWN,
    DISTRICTS_LIST,
    DOC_CODE_PRIMARY_ADDRESS_ADDITIONAL_SUPPORTING_DOC,
    DOC_CODE_PRIMARY_ADDRESS_BILLING_PROOF,
    DOCUMENT_TYPES,
    NOT_AVAILABLE,
    ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION,
    PARAMETER_LIST,
    PREVIEW_DOC_TYPES,
    RADIO_BUTTON_VALUES
} from "../../util/Constants";
import customerService from "../../service/customerService";
import {
    MSG_ALLOWED_DOCUMENT_TYPES_ERROR,
    MSG_ALLOWED_IMAGE_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_COUNTRY_LIST_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";
import {DropdownListDto} from "../../dto/DropdownListDto";
import Validation from "../../util/Validation";
import modal from "antd/es/modal";
import documentService from "../../service/documentService";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import {toNumber} from "lodash";
import PreviewModalComp from "../common/preview/PreviewModalComp";

interface AddressCrProps {
    cin: string
}

interface AddressWrapperDto {
    primaryUpdated: boolean,
    correspondenceUpdated: boolean,
    permanetAddressDto: AddressDto,
    correspondenceAddressDto: AddressDto,
    editable: boolean,
    pendingRequestList: [],
    addressDtoList: []
}

interface DefaultDocDto {
    uid: string
    name: string
    thumbUrl: string
    url: string
    documentTypeId: number
}

const configs = {
    name: 'file',
    multiple: false,
    maxCount: 1
};

const ADDRESS_TYPE_CORRESPONDENCE = "CORRESPONDENCE"
const ADDRESS_TYPE_PRIMARY = "PRIMARY"
const AddressChangeRequestComp = (props: AddressCrProps) => {
    const [permanentAddressForm] = Form.useForm();
    const [correspondentAddressForm] = Form.useForm();
    const [addressList, setAddressList] = useState<AddressDto[]>([])
    const [countryList, setCountryList] = useState<DropdownListDto[]>([]);

    const [isAbleToEdit, setAbleToEdit] = useState<boolean>(true);
    const [isEditDisabled, setEditDisabled] = useState<boolean>(true)

    const [isCorrespondentAddressAvailable, setCorrespondentAddressAvailable] = useState<boolean>(false);
    const [isCorrespondentAddressAvailableTemp, setCorrespondentAddressAvailableTemp] = useState<boolean>(false);
    const [billingProofStatus, setBillingProofStatus] = useState<boolean>(false)
    const [primaryAddressBillingProofStatus, setPrimaryAddressBillingProofStatus] = useState<boolean>(false)

    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false)
    const [isAddDocChanged, setIsAddDocChanged] = useState<boolean>(false)
    const [isBillinProofChanged, setIsBillingProofChanged] = useState<boolean>(false)
    const [isPrimaryAddressAddDocChanged, setPrimaryAddressAddDocChanged] = useState<boolean>(false)
    const [isPrimaryAddressBillinProofChanged, setPrimaryAddressBillingProofChanged] = useState<boolean>(false)
    const [jobId, setJobId] = useState<string>("")
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isloadDistrictsInCorrsSection, loadDistrictsInCorrsSection] = useState(false);
    const [isLoadDistrictsInPermanantSection, loadDistrictsInPermanantSection] = useState(false);

    const [utilityBillUploadedList, setUtilityBillUploadedList] = useState<DefaultDocDto[]>()
    const [primaryAddressUtilityBillUploadedList, setPrimaryAddressUtilityBillUploadedList] = useState<DefaultDocDto[]>()

    const [additionalUploadedList, setAdditionalUploadedList] = useState<DefaultDocDto[]>()
    const [primaryAddressAdditionalUploadedList, setPrimaryAddressAdditionalUploadedList] = useState<DefaultDocDto[]>()
    const [isCanShowPrimaryAddressUploadComp, setCanShowPrimaryAddressUploadComp] = useState<boolean>(false)
    const [tempBillingProfDocId, setTempBillingProofDocId] = useState(0);
    const [tempAsdDocId, setTempAsdDocId] = useState(0);
    const [tempPrimaryAddressBillingProfDocId, setTempPrimaryAddressBillingProofDocId] = useState(0);
    const [tempPrimaryAddressAsdDocId, setTempPrimaryAddressAsdDocId] = useState(0);


    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;


    useEffect(() => {
        getCustomerAddressDetails()
        loadCountryList()
    }, [])
    const getCustomerAddressDetails = () => {
        setSpinnerLoading(true)
        customerChangeRequestService.getCustomerAddressDetailsList(props.cin).then((res) => {
            setAddressList(res.data.results.addressDtoList)
            setFormValue(res.data.results.addressDtoList);
            setAbleToEdit(res.data.results.editable)
        })
    }
    const loadCountryList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.COUNTRY,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setCountryList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_COUNTRY_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const onClickEdit = () => {
        setEditDisabled(!isEditDisabled)
        if (!isEditDisabled) {
            correspondentAddressForm.resetFields()
            setBillingProofStatus(false)
            setCanShowPrimaryAddressUploadComp(false)
            setUtilityBillUploadedList(undefined)
            setAdditionalUploadedList(undefined)
            setFormValue(addressList)
        }
    }
    const setFormValue = (addressList: AddressDto[]) => {


        if (addressList.length > 0) {
            let permanentAddressData: AddressDto | undefined = addressList.find(address => address.type === "PRIMARY");

            if (permanentAddressData) {
                setJobId(permanentAddressData.jobNumber)
                loadUploadedDocuments(permanentAddressData.jobNumber,
                    [DOC_CODE_PRIMARY_ADDRESS_BILLING_PROOF, DOC_CODE_PRIMARY_ADDRESS_ADDITIONAL_SUPPORTING_DOC], true, true)
                let formObj: any = {
                    line1: permanentAddressData.line1,
                    line2: permanentAddressData.line2,
                    townOrCity: permanentAddressData.townOrCity,
                    district: permanentAddressData.district,
                    countryId: permanentAddressData.countryId,
                    postalCode: permanentAddressData.postalCode,
                    type: permanentAddressData.type,
                    id: permanentAddressData.id,
                    billingProofStatus: NOT_AVAILABLE != permanentAddressData.isBillingProofUnderYourName ?
                        permanentAddressData.isBillingProofUnderYourName : RADIO_BUTTON_VALUES.YES,
                    billingProofType: NOT_AVAILABLE != permanentAddressData.billingProofType ?
                        permanentAddressData.billingProofType : RADIO_BUTTON_VALUES.UTILITY_BILL,
                }
                loadDistrictsInPermanantSection("sri lanka" === permanentAddressData.countryName?.toLowerCase())
                setPrimaryAddressBillingProofStatus(RADIO_BUTTON_VALUES.NO === permanentAddressData.isBillingProofUnderYourName)
                permanentAddressForm.setFieldsValue(formObj)
            }

            if (addressList?.length === 2) {

                let correspondentAddressData: AddressDto | undefined = addressList.find(address => address.type === "CORRESPONDENCE");
                if (correspondentAddressData) {
                    // loadUploadedDocuments(correspondentAddressData.jobNumber,
                    //     [DOC_CODE_BILLING_PROOF, DOC_CODE_ADDITIONAL_SUPPORTING_DOC], true, false)
                    let formObj: any = {
                        line1: correspondentAddressData.line1,
                        line2: correspondentAddressData.line2,
                        townOrCity: correspondentAddressData.townOrCity,
                        district: correspondentAddressData.district,
                        countryId: correspondentAddressData.countryId,
                        postalCode: correspondentAddressData.postalCode,
                        type: correspondentAddressData.type,
                        id: correspondentAddressData.id,
                        // billingProofStatus: NOT_AVAILABLE != correspondentAddressData.isBillingProofUnderYourName ?
                        //     correspondentAddressData.isBillingProofUnderYourName : RADIO_BUTTON_VALUES.YES,
                        // billingProofType: NOT_AVAILABLE != correspondentAddressData.billingProofType ?
                        //     correspondentAddressData.billingProofType : RADIO_BUTTON_VALUES.UTILITY_BILL,

                    }
                    loadDistrictsInCorrsSection("sri lanka" === correspondentAddressData.countryName?.toLowerCase())

                    setCorrespondentAddressAvailable(true)
                    setCorrespondentAddressAvailableTemp(true)
                    // setBillingProofStatus(RADIO_BUTTON_VALUES.NO === correspondentAddressData.isBillingProofUnderYourName)
                    correspondentAddressForm.setFieldsValue(formObj)
                }
            }
            setSpinnerLoading(false)
        }
    }
    const loadUploadedDocuments = (jobNo: number | undefined, identityDocumentTypeCodeList: string[], init: boolean, isPrimary: boolean) => {
        if (jobNo) {
            setSpinnerLoading(true)
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {

                    setUploadedDocumentList(res.data.results, init)

                } else {
                    setSpinnerLoading(false)
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                setSpinnerLoading(false)
                ErrorHandler.handleError(reason);
            })
        }

    };

    const setUploadedDocumentList = (documents: any, init: boolean) => {
        documents.forEach((document: any) => {
            if (document.uploadDocumentDetailDto != null) {
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;
                if (uploadDocumentDetailDto.documentTypeId === DOCUMENT_TYPES.BP) {
                    setTempBillingProofDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                } else if (uploadDocumentDetailDto.documentTypeId === DOCUMENT_TYPES.ASD) {
                    setTempAsdDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                } else if (uploadDocumentDetailDto.documentTypeId === DOCUMENT_TYPES.PR_BP) {
                    setCanShowPrimaryAddressUploadComp(true)
                    setTempPrimaryAddressBillingProofDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                } else if (uploadDocumentDetailDto.documentTypeId === DOCUMENT_TYPES.PR_ASD) {
                    setCanShowPrimaryAddressUploadComp(true)
                    setTempPrimaryAddressAsdDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                }
                createUploadedDocuments(uploadDocumentDetailDto, document.documentTypeId, init)
            }

        })
    };
    const onCountryChange = (val: string, isPermanent: boolean) => {
        if (isPermanent) {
            permanentAddressForm.resetFields(['district'])
            loadDistrictsInPermanantSection("sri lanka" === val.toLowerCase())
        } else {
            correspondentAddressForm.resetFields(['district'])
            loadDistrictsInCorrsSection("sri lanka" === val.toLowerCase())
        }

    }

    const onFieldBlur = () => {
        let fieldsValue = permanentAddressForm.getFieldsValue();
        const primaryAddress = addressList.find(address => address.type === "PRIMARY");
        setCanShowPrimaryAddressUploadComp(validateAddressChanges(primaryAddress, fieldsValue, false))
    }
    const getFormItemSet = (isRulesEnabled: boolean, isPermanent: boolean) => {
        return < >
            <div style={{display: "none"}}>
                <Form.Item
                    label=""
                    name={"id"}>
                    <Input/>
                </Form.Item>
            </div>
            <Col xxl={12} xx={12} lg={12} md={24} sm={24}>
                <Form.Item
                    label="Address Line 1"
                    name={"line1"}
                    onKeyPress={Validation.alphanumericAndSpecificSpecialCharacters}
                    rules={isRulesEnabled ? [
                        {required: true, message: 'Please enter address line 1'},
                        {whitespace: true, message: 'Cannot contain whitespaces'},
                        {max: 100, message: 'The maximum length is 100 characters'},
                    ] : []}>

                    <Input onBlur={isPermanent ? onFieldBlur : null} placeholder="Enter address line1"/>
                </Form.Item>
            </Col>

            <Col xxl={12} xx={12} lg={12} md={24} sm={24}>
                <Form.Item
                    label="Address Line 2"
                    name={"line2"}
                    onKeyPress={Validation.alphanumericAndSpecificSpecialCharacters}
                    rules={isRulesEnabled ? [
                        {whitespace: true, message: 'Cannot contain whitespaces'},
                        {max: 100, message: 'The maximum length is 100 characters'},
                    ] : []}>
                    <Input onBlur={isPermanent ? onFieldBlur : null} placeholder="Enter address line2"/>
                </Form.Item>
            </Col>
            <Col xxl={12} xx={12} lg={12} md={12} sm={24}>
                <Form.Item
                    label="Country"
                    name={"countryId"}
                    rules={isRulesEnabled ? [{
                        required: true,
                        message: 'Please select country'
                    }] : []}>
                    <Select placeholder={"Select country"}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, option: {
                                label: any;
                            }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                            style={{width: '100%'}}
                            options={countryList}
                            onChange={(input: any, option: {
                                label: any;
                            }) => onCountryChange(option?.label.toLowerCase(), isPermanent)}
                            onBlur={isPermanent ? onFieldBlur : null}
                    />
                </Form.Item>
            </Col>
            <Col xxl={12} xx={12} lg={12} md={12} sm={24}>
                <Form.Item
                    label="District"
                    name={"district"}
                    onKeyPress={Validation.onlyAlphabeticWithSpace}
                    rules={isRulesEnabled ? [
                        {required: true, message: 'Please enter district'},
                        {whitespace: true, message: 'Cannot contain whitespaces'},
                        {max: 30, message: 'The maximum length is 30 characters'},
                    ] : []}>
                    {

                        isPermanent ?
                            isLoadDistrictsInPermanantSection ?
                                <Select placement='bottomLeft' placeholder={"Select district"} listHeight={180}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input: any, option: {
                                            label: any;
                                        }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        style={{width: '100%'}}
                                        onBlur={isPermanent ? onFieldBlur : null}
                                        options={DISTRICTS_LIST}/> :
                                <Input onBlur={isPermanent ? onFieldBlur : null} placeholder="Enter district"/>
                            :

                            isloadDistrictsInCorrsSection ?
                                <Select placement='bottomLeft' placeholder={"Select district"} listHeight={180}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input: any, option: {
                                            label: any;
                                        }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        style={{width: '100%'}}
                                        options={DISTRICTS_LIST}
                                /> : <Input placeholder="Enter district"/>


                    }

                </Form.Item>
            </Col>
            <Col xxl={12} xx={12} lg={12} md={12} sm={24}>
                <Form.Item
                    label="Town/City"
                    name={"townOrCity"}
                    onKeyPress={Validation.onlyAlphabeticWithSpaceAndNumbers}
                    rules={isRulesEnabled ? [
                        {required: true, message: 'Please enter town/city'},
                        {whitespace: true, message: 'Cannot contain whitespaces'},
                        {max: 20, message: 'The maximum length is 20 characters'},
                        {
                            pattern: ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION,
                            message: 'These special characters are not allowed'
                        }
                    ] : []}>
                    <Input placeholder="Enter town/city" onBlur={isPermanent ? onFieldBlur : null}/>
                </Form.Item>
            </Col>
            <Col xxl={12} xx={12} lg={12} md={12} sm={24}>
                <Form.Item
                    label="Zip Code"
                    name={"postalCode"}
                    onKeyPress={Validation.isNumberWithoutDot}
                    rules={isRulesEnabled ? [{
                        max: 10,
                        message: 'The maximum length is 10 numbers'
                    }] : []}
                >
                    <Input placeholder="Enter zip code" onBlur={isPermanent ? onFieldBlur : null}/>
                </Form.Item>
            </Col>

        </>
    }


    const onClickSubmit = () => {
        let addressWrapperDto = {} as AddressWrapperDto;
        setSpinnerLoading(true)
        let primaryAddressPromise;
        let secondaryAddressPromise;

        const primaryAddress = addressList.find(address => address.type === "PRIMARY");

        const correspondanceAddress = addressList.find(address => address.type === "CORRESPONDENCE");

        if (validateBothAddressChanges(primaryAddress, correspondanceAddress, permanentAddressForm.getFieldsValue(), correspondentAddressForm.getFieldsValue())) {
            primaryAddressPromise = permanentAddressForm.validateFields().then(() => {
                if (validateAddressChanges(primaryAddress, permanentAddressForm.getFieldsValue(), true)) {
                    let addressDto: AddressDto = permanentAddressForm.getFieldsValue(["postalCode",
                        "countryId",
                        "district",
                        "townOrCity",
                        "line2",
                        "line1",
                        "id", "billingProofType", "billingProofStatus"])
                    addressDto.type = ADDRESS_TYPE_PRIMARY
                    addressDto.jobNumber = jobId
                    addressDto.isBillingProofUnderYourName = addressDto.billingProofStatus
                    if (primaryAddressUtilityBillUploadedList && primaryAddressUtilityBillUploadedList?.length > 0) {
                        if (tempPrimaryAddressBillingProfDocId == primaryAddressUtilityBillUploadedList[0].uid) {
                            permanentAddressForm.setFields([
                                {
                                    name: 'uploadUtilityBill',
                                    errors: ['Change billing proof document to continue']
                                }
                            ]);
                            return Promise.reject();
                        }
                        addressDto.billingProofDocId = toNumber(primaryAddressUtilityBillUploadedList[0].uid)
                    }
                    if (primaryAddressAdditionalUploadedList && primaryAddressAdditionalUploadedList?.length > 0) {

                        if (addressDto.billingProofStatus == RADIO_BUTTON_VALUES.NO) {
                            if (tempPrimaryAddressAsdDocId == primaryAddressAdditionalUploadedList[0].uid) {
                                permanentAddressForm.setFields([
                                    {
                                        name: 'uploadAdditional',
                                        errors: ['Change additional supporting document to continue'],
                                    },
                                ]);
                                return Promise.reject();
                            }
                        }
                        addressDto.additionalDocId = toNumber(primaryAddressAdditionalUploadedList[0].uid)
                    } else {
                        if (addressDto.billingProofStatus == RADIO_BUTTON_VALUES.NO) {
                            permanentAddressForm.setFields([
                                {
                                    name: 'uploadAdditional',
                                    errors: ['Upload additional supporting document to continue'],
                                },
                            ]);
                            return Promise.reject();
                        }
                    }
                    addressWrapperDto.primaryUpdated = true
                    addressWrapperDto.permanetAddressDto = addressDto
                } else {
                    let addressDto: AddressDto = primaryAddress
                    addressDto.type = ADDRESS_TYPE_PRIMARY
                    addressDto.jobNumber = jobId
                    if (primaryAddressUtilityBillUploadedList && primaryAddressUtilityBillUploadedList?.length) {
                        addressDto.billingProofDocId = toNumber(primaryAddressUtilityBillUploadedList[0].uid)
                    }
                    if (primaryAddressAdditionalUploadedList && primaryAddressAdditionalUploadedList?.length) {
                        addressDto.additionalDocId = toNumber(primaryAddressAdditionalUploadedList[0].uid)
                    }
                    addressWrapperDto.primaryUpdated = false
                    addressWrapperDto.permanetAddressDto = addressDto
                }
                return Promise.resolve();
            }).catch(() => {
                return Promise.reject();
            })

            if (isCorrespondentAddressAvailable) {
                secondaryAddressPromise = correspondentAddressForm.validateFields().then(() => {
                    if (validateAddressChanges(correspondanceAddress, correspondentAddressForm.getFieldsValue(), false)) {

                        let addressDto: AddressDto = correspondentAddressForm.getFieldsValue(["postalCode",
                            "countryId",
                            "district",
                            "townOrCity",
                            "line2",
                            "line1",
                            "id",
                            // "billingProofType", "billingProofStatus"
                        ])
                        addressDto.type = ADDRESS_TYPE_CORRESPONDENCE
                        addressDto.jobNumber = jobId
                        // addressDto.isBillingProofUnderYourName = addressDto.billingProofStatus
                        // if (utilityBillUploadedList && utilityBillUploadedList?.length > 0) {
                        //     if (tempBillingProfDocId == utilityBillUploadedList[0].uid) {
                        //         correspondentAddressForm.setFields([
                        //             {
                        //                 name: 'uploadUtilityBill',
                        //                 errors: ['Change billing proof document to continue']
                        //             }
                        //         ]);
                        //         return Promise.reject();
                        //     }
                        //     addressDto.billingProofDocId = toNumber(utilityBillUploadedList[0].uid)
                        // }
                        // if (additionalUploadedList && additionalUploadedList?.length > 0) {
                        //
                        //     if (addressDto.billingProofStatus == RADIO_BUTTON_VALUES.NO) {
                        //         if (tempAsdDocId == additionalUploadedList[0].uid) {
                        //             correspondentAddressForm.setFields([
                        //                 {
                        //                     name: 'uploadAdditional',
                        //                     errors: ['Change additional supporting document to continue'],
                        //                 },
                        //             ]);
                        //             return Promise.reject();
                        //         }
                        //     }
                        //     addressDto.additionalDocId = toNumber(additionalUploadedList[0].uid)
                        // }
                        // else {
                        //     if (addressDto.billingProofStatus == RADIO_BUTTON_VALUES.NO) {
                        //         correspondentAddressForm.setFields([
                        //             {
                        //                 name: 'uploadAdditional',
                        //                 errors: ['Upload additional supporting document to continue'],
                        //             },
                        //         ]);
                        //         return Promise.reject();
                        //     }
                        // }
                        addressWrapperDto.correspondenceUpdated = true
                        addressWrapperDto.correspondenceAddressDto = addressDto
                    } else {
                        let addressDto: AddressDto = correspondanceAddress
                        addressDto.type = ADDRESS_TYPE_CORRESPONDENCE
                        addressDto.jobNumber = jobId
                        // if (utilityBillUploadedList && utilityBillUploadedList?.length) {
                        //     addressDto.billingProofDocId = toNumber(utilityBillUploadedList[0].uid)
                        // }
                        // if (additionalUploadedList && additionalUploadedList?.length) {
                        //     addressDto.additionalDocId = toNumber(additionalUploadedList[0].uid)
                        // }
                        addressWrapperDto.correspondenceUpdated = false
                        addressWrapperDto.correspondenceAddressDto = addressDto
                    }
                    return Promise.resolve();
                }).catch(() => {
                    return Promise.reject();
                })
            } else {
                if (validateAddressChanges(correspondanceAddress, correspondentAddressForm.getFieldsValue(), false)) {
                    //this set true to validate all required fields is system detect secondary account change where
                    //user not filled in onboarding process
                    setCorrespondentAddressAvailable(true)
                    //---
                    secondaryAddressPromise = correspondentAddressForm.validateFields().then(() => {
                        let addressDto: AddressDto = correspondentAddressForm.getFieldsValue(["postalCode",
                            "countryId",
                            "district",
                            "townOrCity",
                            "line2",
                            "line1",
                            "id",
                            // "billingProofStatus", "billingProofType"
                        ])


                        // if (utilityBillUploadedList && utilityBillUploadedList.length > 0) {
                        //     addressDto.billingProofDocId = toNumber(utilityBillUploadedList[0].uid)
                        // } else {
                        //     correspondentAddressForm.setFields([
                        //         {
                        //             name: 'uploadUtilityBill',
                        //             errors: ['Upload billing proof to continue'],
                        //         },
                        //     ]);
                        //     return Promise.reject();
                        // }

                        // if (additionalUploadedList && additionalUploadedList.length > 0) {
                        //     addressDto.additionalDocId = toNumber(additionalUploadedList[0].uid)
                        // } else {
                        //     if (addressDto.billingProofStatus == RADIO_BUTTON_VALUES.NO) {
                        //         correspondentAddressForm.setFields([
                        //             {
                        //                 name: 'uploadAdditional',
                        //                 errors: ['Upload additional support document to continue'],
                        //             },
                        //         ]);
                        //         return Promise.reject();
                        //     }
                        // }
                        addressDto.type = ADDRESS_TYPE_CORRESPONDENCE
                        addressDto.jobNumber = jobId
                        addressDto.isBillingProofUnderYourName = addressDto.billingProofStatus
                        addressWrapperDto.correspondenceUpdated = true
                        addressWrapperDto.correspondenceAddressDto = addressDto
                    }).catch(() => {
                        return Promise.reject();
                    })

                } else {
                    secondaryAddressPromise = correspondentAddressForm.validateFields()
                    let addressDto: AddressDto = {
                        postalCode: "",
                        countryId: "",
                        district: "",
                        townOrCity: "",
                        line2: "",
                        line1: "",
                    } as AddressDto;
                    addressDto.type = ADDRESS_TYPE_CORRESPONDENCE
                    addressDto.jobNumber = jobId
                    // if (utilityBillUploadedList) {
                    //     addressDto.billingProofDocId = toNumber(utilityBillUploadedList[0].uid)
                    // }
                    // if (additionalUploadedList) {
                    //     addressDto.additionalDocId = toNumber(additionalUploadedList[0].uid)
                    // }
                    addressWrapperDto.correspondenceUpdated = false
                    addressWrapperDto.correspondenceAddressDto = addressDto
                }
            }

            Promise.all([primaryAddressPromise, secondaryAddressPromise])
                .then(() => {
                    modal.confirm({
                        title: 'Confirm',
                        icon: <ExclamationCircleOutlined/>,
                        content: `Are you sure?, Do you want to update the address detail?`,
                        okText: 'Yes',
                        cancelText: 'No',
                        className: 'confirm-dialog-box',
                        okButtonProps: {style: {background: '#FF7400'}},
                        onOk() {
                            customerChangeRequestService.submitAddressChangeRequest(addressWrapperDto, props.cin).then((res) => {
                                message.success("Successfully submitted to authorization")
                                setAddressList(res.data.results.addressDtoList)
                                setAbleToEdit(res.data.results.editable)
                                setSpinnerLoading(false)
                            }, (reason) => {
                                ErrorHandler.handleError(reason);
                                setSpinnerLoading(false)
                            })
                        },
                        onCancel() {
                            setSpinnerLoading(false)
                        }
                    });

                })
                .catch(() => {
                    message.warning("Fill all required fields!");
                    setSpinnerLoading(false);
                });

        } else {
            //this field set to false to remove triggered validations in secondary section if no changedetected
            // if (!isCorrespondentAddressAvailableTemp) {
            //     setCorrespondentAddressAvailable(false)
            // }

            correspondentAddressForm.validateFields()
            permanentAddressForm.validateFields()
            message.warning("No changes detected")
            setSpinnerLoading(false)
        }

    }

    const validateBothAddressChanges = (currentPermanentAddressDto: AddressDto | undefined, currentCorrespondentAddressDto: AddressDto | undefined,
                                        fieldValuesPermanentAddr: AddressDto, fieldValuesCorresAddr: AddressDto) => {

        return validateAddressChanges(currentPermanentAddressDto, fieldValuesPermanentAddr, true) ||
            validateAddressChanges(currentCorrespondentAddressDto, fieldValuesCorresAddr, false)
    }
    const validateAddressChanges = (addressDto: AddressDto | undefined, fieldValues: AddressDto, isPrimary: boolean): boolean => {
        let validatedtAddress: AddressDto = addressDto ? addressDto : {
            postalCode: "",
            countryId: "",
            district: "",
            townOrCity: "",
            line2: "",
            line1: "",
            billingProofType: "",
            isBillingProofUnderYourName: "",
            billingProofStatus: "",
        } as AddressDto


        if (validateFieldValues(validatedtAddress.line1) != validateFieldValues(fieldValues.line1)) {
            return true;
        } else if (validateFieldValues(validatedtAddress.line2) != validateFieldValues(fieldValues.line2)) {
            return true;
        } else if (validateFieldValues(validatedtAddress.townOrCity) != validateFieldValues(fieldValues.townOrCity)) {
            return true;
        } else if (validateFieldValues(validatedtAddress.district) != validateFieldValues(fieldValues.district)) {
            return true;
        } else if (validateFieldValues(validatedtAddress.countryId) != validateFieldValues(fieldValues.countryId)) {
            return true;
        } else if (validateFieldValues(validatedtAddress.postalCode) != validateFieldValues(fieldValues.postalCode)) {
            return true;
        }


        if (isPrimary) {
            if (validateFieldValues(validatedtAddress.isBillingProofUnderYourName) != validateFieldValues(fieldValues.billingProofStatus)) {
                return true;
            } else if (validateFieldValues(validatedtAddress.billingProofType) != validateFieldValues(fieldValues.billingProofType)) {
                return true;
            } else if (isPrimaryAddressBillinProofChanged) {
                return true;
            } else if (isPrimaryAddressAddDocChanged) {
                return true;
            }
        }
        // else {
        //     if (validateFieldValues(validatedtAddress.isBillingProofUnderYourName) != validateFieldValues(fieldValues.billingProofStatus)) {
        //         return true;
        //     } else if (validateFieldValues(validatedtAddress.billingProofType) != validateFieldValues(fieldValues.billingProofType)) {
        //         return true;
        //     } else if (isBillinProofChanged) {
        //         return true;
        //     } else if (isAddDocChanged) {
        //         return true;
        //     }
        // }

        return false;

    }
    // const onBillingProofStatusChange = (evt: Event) => {
    //     let value = (evt.target as HTMLInputElement).value as unknown as string;
    //     if (additionalUploadedList && additionalUploadedList?.length > 0) {
    //         onRemove(additionalUploadedList ? additionalUploadedList[0].documentTypeId : 0)
    //     }
    //     if (utilityBillUploadedList && utilityBillUploadedList?.length > 0) {
    //         onRemove(utilityBillUploadedList ? utilityBillUploadedList[0].documentTypeId : 0)
    //     }
    //
    //     setBillingProofStatus(RADIO_BUTTON_VALUES.NO === value)
    // };

    const onPrimaryAddressBillingProofStatusChange = (evt: Event) => {
        let value = (evt.target as HTMLInputElement).value as unknown as string;
        if (primaryAddressAdditionalUploadedList && primaryAddressAdditionalUploadedList?.length > 0) {
            onRemove(primaryAddressAdditionalUploadedList ? primaryAddressAdditionalUploadedList[0].documentTypeId : 0)
        }
        if (primaryAddressUtilityBillUploadedList && primaryAddressUtilityBillUploadedList?.length > 0) {
            onRemove(primaryAddressUtilityBillUploadedList ? primaryAddressUtilityBillUploadedList[0].documentTypeId : 0)
        }


        setPrimaryAddressBillingProofStatus(RADIO_BUTTON_VALUES.NO === value)
    };
    const validateFieldValues = (value: any) => {
        return value ?? ""
    }

    // const beforeUploadASD = (file: any) => {
    //     setIsAddDocChanged(true)
    //     return validateDocument(file, DOCUMENT_TYPES.ASD_TEMP, ALLOWED_IMAGE_TYPES);
    // };
    // const beforeUploadUtilityBill = (file: any) => {
    //     setIsBillingProofChanged(true)
    //     return validateDocument(file, DOCUMENT_TYPES.BP_TEMP, ALLOWED_IMAGE_TYPES);
    // };
    const beforeUploadPrimaryAddressUtilityBill = (file: any) => {
        setPrimaryAddressBillingProofChanged(true)
        return validateDocument(file, DOCUMENT_TYPES.PR_BP_TEMP, ALLOWED_IMAGE_TYPES);
    };

    const beforeUploadPrimaryAddressASD = (file: any) => {
        setPrimaryAddressAddDocChanged(true)
        return validateDocument(file, DOCUMENT_TYPES.PR_ASD_TEMP, ALLOWED_IMAGE_TYPES);
    };
    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setSpinnerLoading(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(JSON.stringify(allowedDocTypes) === JSON.stringify(ALLOWED_IMAGE_TYPES) ? MSG_ALLOWED_IMAGE_TYPES_ERROR : MSG_ALLOWED_DOCUMENT_TYPES_ERROR);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", jobId);
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, false)
                setSpinnerLoading(false)
            } else {
                setSpinnerLoading(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };
    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number, init: boolean) => {
        setSpinnerLoading(false)
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath,
                    documentTypeId: documentTypeId
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.BP_TEMP || documentTypeId == DOCUMENT_TYPES.BP) {
            setUtilityBillUploadedList(defaultFileList)
            correspondentAddressForm.setFieldsValue({uploadUtilityBill: defaultFileList})

        } else if (documentTypeId == DOCUMENT_TYPES.ASD_TEMP || documentTypeId == DOCUMENT_TYPES.ASD) {
            correspondentAddressForm.setFieldsValue({uploadAdditional: defaultFileList})
            setAdditionalUploadedList(defaultFileList)

        } else if (documentTypeId == DOCUMENT_TYPES.PR_BP_TEMP || documentTypeId == DOCUMENT_TYPES.PR_BP) {
            permanentAddressForm.setFieldsValue({uploadUtilityBill: defaultFileList})
            setPrimaryAddressUtilityBillUploadedList(defaultFileList)

        } else if (documentTypeId == DOCUMENT_TYPES.PR_ASD_TEMP || documentTypeId == DOCUMENT_TYPES.PR_ASD) {
            permanentAddressForm.setFieldsValue({uploadAdditional: defaultFileList})
            setPrimaryAddressAdditionalUploadedList(defaultFileList)

        }
    };
    const onRemove = (docId: DOCUMENT_TYPES) => {
        if (docId != 0) {
            setSpinnerLoading(true)
            if (DOCUMENT_TYPES.BP == docId) {
                setUtilityBillUploadedList([])
                setIsBillingProofChanged(true)
                correspondentAddressForm.setFieldsValue({uploadUtilityBill: []})
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.ASD == docId) {
                setAdditionalUploadedList([])
                correspondentAddressForm.setFieldsValue({uploadAdditional: []})
                setIsBillingProofChanged(true)
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.BP_TEMP == docId) {
                setUtilityBillUploadedList([])
                setIsBillingProofChanged(true)
                correspondentAddressForm.setFieldsValue({uploadUtilityBill: []})
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.ASD_TEMP == docId) {
                setAdditionalUploadedList([])
                correspondentAddressForm.setFieldsValue({uploadAdditional: []})
                setIsBillingProofChanged(true)
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.PR_BP == docId) {
                setPrimaryAddressUtilityBillUploadedList([])
                permanentAddressForm.setFieldsValue({uploadUtilityBill: []})
                setPrimaryAddressBillingProofChanged(true)
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.PR_ASD == docId) {
                setPrimaryAddressAdditionalUploadedList([])
                permanentAddressForm.setFieldsValue({uploadAdditional: []})
                setPrimaryAddressAddDocChanged(true)
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.PR_BP_TEMP == docId) {
                setPrimaryAddressUtilityBillUploadedList([])
                permanentAddressForm.setFieldsValue({uploadUtilityBill: []})
                setPrimaryAddressBillingProofChanged(true)
                setSpinnerLoading(false)
            } else if (DOCUMENT_TYPES.PR_ASD_TEMP == docId) {
                setPrimaryAddressAdditionalUploadedList([])
                permanentAddressForm.setFieldsValue({uploadAdditional: []})
                setPrimaryAddressAddDocChanged(true)
                setSpinnerLoading(false)
            } else {
                let uid: string = "";
                if (DOCUMENT_TYPES.BP_TEMP === docId) {
                    uid = utilityBillUploadedList[0].uid
                } else if (DOCUMENT_TYPES.ASD_TEMP === docId) {
                    uid = additionalUploadedList[0].uid
                } else if (DOCUMENT_TYPES.PR_ASD_TEMP === docId) {
                    uid = primaryAddressAdditionalUploadedList[0].uid
                } else if (DOCUMENT_TYPES.PR_BP_TEMP === docId) {
                    uid = primaryAddressUtilityBillUploadedList[0].uid
                }

                documentService.deleteDocumentById(uid).then(res => {
                    if (res.data !== null) {
                        setSpinnerLoading(false)
                        if (DOCUMENT_TYPES.BP_TEMP === docId) {
                            setUtilityBillUploadedList([])
                            setIsBillingProofChanged(true)
                        } else if (DOCUMENT_TYPES.ASD_TEMP === docId) {
                            setAdditionalUploadedList([])
                            setIsBillingProofChanged(true)
                        } else if (DOCUMENT_TYPES.PR_ASD_TEMP === docId) {
                            setPrimaryAddressAdditionalUploadedList([])
                            setPrimaryAddressAddDocChanged(true)
                        } else if (DOCUMENT_TYPES.PR_BP_TEMP === docId) {
                            setPrimaryAddressUtilityBillUploadedList([])
                            setPrimaryAddressBillingProofChanged(true)
                        }

                    } else {
                        message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                        setSpinnerLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setSpinnerLoading(false)
                })
            }

            return true;
        }

    };
    const normFile = (e: { fileList: any; }) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const onPreview = (documentId: string, docTypeName: string) => {
        setSpinnerLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setIsModalOpen(false)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinnerLoading(false)
            }
        }, (reason) => {
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const handleCheckBoxChange = (value: boolean) => {
        setCorrespondentAddressAvailable(value)

        if (!value) {
            correspondentAddressForm.validateFields()
            correspondentAddressForm.resetFields()
            setAdditionalUploadedList([])
            setUtilityBillUploadedList([])
        }

    }
    return (
        <Spin spinning={isSpinnerLoading}>
            <Row gutter={[24, 24]}>
                {
                    !isAbleToEdit ?
                        <Col span={24} style={{marginBottom: 8}}>
                            <Alert
                                message="A new request cannot be processed because a request has already been raised."
                                type="warning" showIcon/>
                        </Col>
                        :
                        <Col span={24} className={'request-screen-edit-btn-position'}>
                            <Space style={{float: 'right'}}>
                                <Button
                                    style={{
                                        width: 84,
                                    }}
                                    onClick={onClickEdit}
                                >Edit</Button>
                            </Space>
                        </Col>
                }

                <Col span={24}>
                    <Card title="Permanent Address">
                        <Form
                            className='form-input'
                            layout={"vertical"}
                            form={permanentAddressForm}
                            disabled={!isAbleToEdit || isEditDisabled}
                        >
                            <Row gutter={[12, 12]}>
                                {
                                    getFormItemSet(true, true)
                                }
                                {isCanShowPrimaryAddressUploadComp ?
                                    <>
                                        <Col span={24}>
                                            <Form.Item className='upload-form-item-lbl'
                                                       label={
                                                           <>
                                                               <h4 className='account-create-form-subheader'
                                                                   style={{marginBottom: 0}}>Upload Your Billing
                                                                   Proof</h4>
                                                           </>
                                                       }
                                                       rules={
                                                           [{
                                                               required: true,
                                                               message: 'Please select billing proof status'
                                                           }]}>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={12} xx={12} lg={12} md={24} sm={24}>
                                            <Form.Item className='upload-form-item-radio-btn'
                                                       label="Is the Billing Proof Under Your Name?"
                                                       name={"billingProofStatus"}
                                                       rules={
                                                           [{
                                                               required: true,
                                                               message: 'Please select billing proof status'
                                                           }]}>
                                                <Radio.Group onChange={onPrimaryAddressBillingProofStatusChange}
                                                             style={{marginTop: 4}}>
                                                    <Radio value={RADIO_BUTTON_VALUES.YES}>Yes</Radio>
                                                    <Radio value={RADIO_BUTTON_VALUES.NO}>No</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={12} xx={12} lg={12} md={24} sm={24}>
                                            <Form.Item className='upload-form-item-radio-btn'
                                                       label="Please Select the Billing Proof Type"
                                                       name={"billingProofType"}
                                                       rules={
                                                           [{
                                                               required: true,
                                                               message: 'Please select billing proof type'
                                                           }]}>
                                                <Radio.Group style={{marginTop: 4}}>
                                                    <Radio value={RADIO_BUTTON_VALUES.PRIMARY_ADDRESS_CHANGE}>Address
                                                        changed new NIC or Drivers Licence</Radio>
                                                    <Radio value={RADIO_BUTTON_VALUES.UTILITY_BILL}>Utility Bill</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                    </> : <></>}
                            </Row>
                            {isCanShowPrimaryAddressUploadComp ? <Row gutter={[12, 12]}>
                                <Col xxl={12} xx={12} lg={12} md={24} sm={24}>
                                    <Row gutter={[12, 12]}>

                                        <Col span={24}>
                                            <Form.Item
                                                label="Billing Proof"
                                                name={"uploadUtilityBill"}
                                                initialValue={primaryAddressUtilityBillUploadedList && primaryAddressUtilityBillUploadedList?.length > 0 ? [primaryAddressUtilityBillUploadedList] : undefined}
                                                getValueFromEvent={normFile}
                                                style={{marginBottom: 4}}
                                                rules={[{
                                                    required: true,
                                                    message: 'Please upload your billing proof'
                                                }]}
                                            >
                                                <Upload {...configs}
                                                        className='upload_comp'
                                                        accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                        listType="picture"
                                                        onPreview={(e: any) => {
                                                            onPreview(primaryAddressUtilityBillUploadedList ? primaryAddressUtilityBillUploadedList[0].uid : '',
                                                                primaryAddressUtilityBillUploadedList ? primaryAddressUtilityBillUploadedList[0].name : '')
                                                        }}
                                                        onRemove={(e: any) => onRemove(primaryAddressUtilityBillUploadedList ? primaryAddressUtilityBillUploadedList[0].documentTypeId : 0)}
                                                        fileList={primaryAddressUtilityBillUploadedList && primaryAddressUtilityBillUploadedList?.length > 0 ? primaryAddressUtilityBillUploadedList : undefined}
                                                        beforeUpload={beforeUploadPrimaryAddressUtilityBill}
                                                >
                                                    {(undefined != primaryAddressUtilityBillUploadedList ? primaryAddressUtilityBillUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{fontSize: 20, color: '#757575'}}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                <span>
                                                                    Upload the Billing Proof Document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>
                                            </Form.Item>

                                        </Col>
                                        <Col span={24}>
                                            <Alert style={{marginBottom: 10}} className='note-alert'
                                                   description={
                                                       <>
                                                           <b>Note : </b>The billing proof document should be within 6
                                                           months of
                                                           the period.
                                                       </>
                                                   }
                                                   type="warning"
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xxl={12} xx={12} lg={12} md={24} sm={24}>
                                    {primaryAddressBillingProofStatus ?
                                        <Row gutter={[12, 12]}>

                                            <Col span={24}>

                                                <Form.Item
                                                    label="Additional Supporting Document"
                                                    name={"uploadAdditional"}
                                                    style={{marginBottom: 4}}
                                                    initialValue={primaryAddressAdditionalUploadedList && primaryAddressAdditionalUploadedList?.length > 0 ? [primaryAddressAdditionalUploadedList] : undefined}
                                                    getValueFromEvent={normFile}
                                                    rules={[{
                                                        required: true,
                                                        message: 'Please upload your additional supporting document'
                                                    }]}
                                                >
                                                    <Upload {...configs}
                                                            className='upload_comp'
                                                            listType="picture"
                                                            accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                            onPreview={(e: any) => {
                                                                primaryAddressAdditionalUploadedList
                                                                onPreview(primaryAddressAdditionalUploadedList ? primaryAddressAdditionalUploadedList[0].uid : '',
                                                                    primaryAddressAdditionalUploadedList ? primaryAddressAdditionalUploadedList[0].name : '')
                                                            }}
                                                            onRemove={(e: any) => onRemove(primaryAddressAdditionalUploadedList ? primaryAddressAdditionalUploadedList[0].documentTypeId : 0)}
                                                            fileList={primaryAddressAdditionalUploadedList && primaryAddressAdditionalUploadedList?.length > 0 ? primaryAddressAdditionalUploadedList : undefined}
                                                            beforeUpload={beforeUploadPrimaryAddressASD}

                                                    >
                                                        {(undefined != primaryAddressAdditionalUploadedList ? primaryAddressAdditionalUploadedList.length : [].length) < 1 &&
                                                            <Button>
                                                                <div className='upload-btn-div'>
                                                                    <div className="upload-icon-div">
                                                                        <PlusOutlined
                                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                                    </div>
                                                                    <div className="upload-btn-text-div">
                                                                    <span>
                                                                      Upload the Additional Supporting Document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                    </span>
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        }
                                                    </Upload>
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    style={{marginBottom: 0}}
                                                    label={""}
                                                >
                                                    <Alert style={{marginBottom: 10}} className='note-alert'
                                                           description={
                                                               <>
                                                                   <b>Note : </b>For documentation purposes, you may be
                                                                   required
                                                                   to
                                                                   provide supporting documents such as a rent
                                                                   agreement,
                                                                   marriage
                                                                   certificate, or birth certificate, among others.
                                                               </>
                                                           }
                                                           type="warning"
                                                    />
                                                </Form.Item>

                                            </Col>
                                        </Row> : <></>
                                    }
                                </Col>

                            </Row> : <></>}
                        </Form>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card title={<span>
                        Correspondence Address
                        <Checkbox style={{marginLeft: 10}}
                                  onChange={() => handleCheckBoxChange(!isCorrespondentAddressAvailable)}
                                  disabled={isCorrespondentAddressAvailableTemp}
                                  checked={isCorrespondentAddressAvailable}>
                            </Checkbox>
                    </span>}

                    >
                        <Form
                            className='form-input'
                            layout={"vertical"}
                            form={correspondentAddressForm}
                            disabled={!isAbleToEdit || isEditDisabled}
                        >

                            <Row gutter={[12, 12]}>

                                {
                                    getFormItemSet(isCorrespondentAddressAvailable, false)

                                }
                                {/*<Col span={24}>*/}
                                {/*    <Form.Item className='upload-form-item-lbl'*/}
                                {/*               label={*/}
                                {/*                   <>*/}
                                {/*                       <h4 className='account-create-form-subheader'*/}
                                {/*                           style={{marginBottom: 0}}>Upload Your Billing Proof</h4>*/}
                                {/*                   </>*/}
                                {/*               }*/}
                                {/*               rules={*/}
                                {/*                   [{*/}
                                {/*                       required: true,*/}
                                {/*                       message: 'Please select billing proof status'*/}
                                {/*                   }]}>*/}
                                {/*    </Form.Item>*/}
                                {/*</Col>*/}
                                {/*<Col xxl={12} xx={12} lg={12} md={24} sm={24}>*/}
                                {/*    <Form.Item className='upload-form-item-radio-btn'*/}
                                {/*               label="Is the Billing Proof Under Your Name?"*/}
                                {/*               name={"billingProofStatus"}*/}
                                {/*               rules={*/}
                                {/*                   [{*/}
                                {/*                       required: isCorrespondentAddressAvailable,*/}
                                {/*                       message: 'Please select billing proof status'*/}
                                {/*                   }]}>*/}
                                {/*        <Radio.Group onChange={onBillingProofStatusChange} style={{marginTop: 4}}>*/}
                                {/*            <Radio value={RADIO_BUTTON_VALUES.YES}>Yes</Radio>*/}
                                {/*            <Radio value={RADIO_BUTTON_VALUES.NO}>No</Radio>*/}
                                {/*        </Radio.Group>*/}
                                {/*    </Form.Item>*/}
                                {/*</Col>*/}
                                {/*<Col xxl={12} xx={12} lg={12} md={24} sm={24}>*/}
                                {/*    <Form.Item className='upload-form-item-radio-btn'*/}
                                {/*               label="Please Select the Billing Proof Type"*/}
                                {/*               name={"billingProofType"}*/}
                                {/*               rules={*/}
                                {/*                   [{*/}
                                {/*                       required: isCorrespondentAddressAvailable,*/}
                                {/*                       message: 'Please select billing proof type'*/}
                                {/*                   }]}>*/}
                                {/*        <Radio.Group style={{marginTop: 4}}>*/}
                                {/*            <Radio value={RADIO_BUTTON_VALUES.UTILITY_BILL}>Utility Bill</Radio>*/}
                                {/*            /!*<Radio value={RADIO_BUTTON_VALUES.BANK_STATEMENT}>Bank Statement</Radio>*!/*/}
                                {/*        </Radio.Group>*/}
                                {/*    </Form.Item>*/}
                                {/*</Col>*/}
                            </Row>
                            {/*<Row gutter={[12, 12]}>*/}
                            {/*    <Col xxl={12} xx={12} lg={12} md={24} sm={24}>*/}
                            {/*        <Row gutter={[12, 12]}>*/}

                            {/*            <Col span={24}>*/}
                            {/*                <Form.Item*/}
                            {/*                    label="Billing Proof"*/}
                            {/*                    name={"uploadUtilityBill"}*/}
                            {/*                    initialValue={utilityBillUploadedList && utilityBillUploadedList?.length > 0 ? [utilityBillUploadedList] : undefined}*/}
                            {/*                    getValueFromEvent={normFile}*/}
                            {/*                    style={{marginBottom: 4}}*/}
                            {/*                    rules={[{*/}
                            {/*                        required: isCorrespondentAddressAvailable,*/}
                            {/*                        message: 'Please upload your billing proof'*/}
                            {/*                    }]}*/}
                            {/*                >*/}
                            {/*                    <Upload {...configs}*/}
                            {/*                            className='upload_comp'*/}
                            {/*                            accept={ALLOWED_IMAGE_TYPE_EXTENSION}*/}
                            {/*                            listType="picture"*/}
                            {/*                            onPreview={(e: any) => {*/}
                            {/*                                onPreview(utilityBillUploadedList ? utilityBillUploadedList[0].uid : '',*/}
                            {/*                                    utilityBillUploadedList ? utilityBillUploadedList[0].name : '')*/}
                            {/*                            }}*/}
                            {/*                            onRemove={(e: any) => onRemove(utilityBillUploadedList ? utilityBillUploadedList[0].documentTypeId : 0)}*/}
                            {/*                            fileList={utilityBillUploadedList && utilityBillUploadedList?.length > 0 ? utilityBillUploadedList : undefined}*/}
                            {/*                            beforeUpload={beforeUploadUtilityBill}*/}
                            {/*                    >*/}
                            {/*                        {(undefined != utilityBillUploadedList ? utilityBillUploadedList.length : [].length) < 1 &&*/}
                            {/*                            <Button>*/}
                            {/*                                <div className='upload-btn-div'>*/}
                            {/*                                    <div className="upload-icon-div">*/}
                            {/*                                        <PlusOutlined*/}
                            {/*                                            style={{fontSize: 20, color: '#757575'}}/>*/}
                            {/*                                    </div>*/}
                            {/*                                    <div className="upload-btn-text-div">*/}
                            {/*                                    <span>*/}
                            {/*                                        Upload the Billing Proof Document {ALLOWED_IMAGE_TYPES_TEXT}*/}
                            {/*                                    </span>*/}
                            {/*                                    </div>*/}
                            {/*                                </div>*/}
                            {/*                            </Button>*/}
                            {/*                        }*/}
                            {/*                    </Upload>*/}
                            {/*                </Form.Item>*/}

                            {/*            </Col>*/}
                            {/*            <Col span={24}>*/}
                            {/*                <Alert style={{marginBottom: 10}} className='note-alert'*/}
                            {/*                       description={*/}
                            {/*                           <>*/}
                            {/*                               <b>Note : </b>The billing proof document should be within 6*/}
                            {/*                               months of*/}
                            {/*                               the period.*/}
                            {/*                           </>*/}
                            {/*                       }*/}
                            {/*                       type="warning"*/}
                            {/*                />*/}
                            {/*            </Col>*/}
                            {/*        </Row>*/}
                            {/*    </Col>*/}

                            {/*    <Col xxl={12} xx={12} lg={12} md={24} sm={24}>*/}
                            {/*        {billingProofStatus ?*/}
                            {/*            <Row gutter={[12, 12]}>*/}

                            {/*                <Col span={24}>*/}

                            {/*                    <Form.Item*/}
                            {/*                        label="Additional Supporting Document"*/}
                            {/*                        name={"uploadAdditional"}*/}
                            {/*                        style={{marginBottom: 4}}*/}
                            {/*                        initialValue={additionalUploadedList && additionalUploadedList?.length > 0 ? [additionalUploadedList] : undefined}*/}
                            {/*                        getValueFromEvent={normFile}*/}
                            {/*                        rules={[{*/}
                            {/*                            required: true,*/}
                            {/*                            message: 'Please upload your additional supporting document'*/}
                            {/*                        }]}*/}
                            {/*                    >*/}
                            {/*                        <Upload {...configs}*/}
                            {/*                                className='upload_comp'*/}
                            {/*                                listType="picture"*/}
                            {/*                                accept={ALLOWED_IMAGE_TYPE_EXTENSION}*/}
                            {/*                                onPreview={(e: any) => {*/}
                            {/*                                    onPreview(additionalUploadedList ? additionalUploadedList[0].uid : '',*/}
                            {/*                                        additionalUploadedList ? additionalUploadedList[0].name : '')*/}
                            {/*                                }}*/}
                            {/*                                onRemove={(e: any) => onRemove(additionalUploadedList ? additionalUploadedList[0].documentTypeId : 0)}*/}
                            {/*                                fileList={additionalUploadedList && additionalUploadedList?.length > 0 ? additionalUploadedList : undefined}*/}
                            {/*                                beforeUpload={beforeUploadASD}*/}

                            {/*                        >*/}
                            {/*                            {(undefined != additionalUploadedList ? additionalUploadedList.length : [].length) < 1 &&*/}
                            {/*                                <Button>*/}
                            {/*                                    <div className='upload-btn-div'>*/}
                            {/*                                        <div className="upload-icon-div">*/}
                            {/*                                            <PlusOutlined*/}
                            {/*                                                style={{fontSize: 20, color: '#757575'}}/>*/}
                            {/*                                        </div>*/}
                            {/*                                        <div className="upload-btn-text-div">*/}
                            {/*                                        <span>*/}
                            {/*                                          Upload the Additional Supporting Document {ALLOWED_IMAGE_TYPES_TEXT}*/}
                            {/*                                        </span>*/}
                            {/*                                        </div>*/}
                            {/*                                    </div>*/}
                            {/*                                </Button>*/}
                            {/*                            }*/}
                            {/*                        </Upload>*/}
                            {/*                    </Form.Item>*/}
                            {/*                </Col>*/}
                            {/*                <Col span={24}>*/}
                            {/*                    <Form.Item*/}
                            {/*                        style={{marginBottom: 0}}*/}
                            {/*                        label={""}*/}
                            {/*                    >*/}
                            {/*                        <Alert style={{marginBottom: 10}} className='note-alert'*/}
                            {/*                               description={*/}
                            {/*                                   <>*/}
                            {/*                                       <b>Note : </b>For documentation purposes, you may be*/}
                            {/*                                       required*/}
                            {/*                                       to*/}
                            {/*                                       provide supporting documents such as a rent*/}
                            {/*                                       agreement,*/}
                            {/*                                       marriage*/}
                            {/*                                       certificate, or birth certificate, among others.*/}
                            {/*                                   </>*/}
                            {/*                               }*/}
                            {/*                               type="warning"*/}
                            {/*                        />*/}
                            {/*                    </Form.Item>*/}

                            {/*                </Col>*/}
                            {/*            </Row> : <></>*/}
                            {/*        }*/}
                            {/*    </Col>*/}

                            {/*</Row>*/}
                        </Form>
                    </Card>
                </Col>
                <Col span={24}>
                    <Divider style={{marginBottom: 12}}/>
                </Col>
                <Col span={24}>
                    <Space style={{float: 'right'}}>
                        {/*<Button size={'large'}*/}
                        {/*        style={{*/}
                        {/*            width: 120,*/}
                        {/*            marginRight: 8*/}
                        {/*        }}>Cancel</Button>*/}
                        <Button size={'large'} disabled={!isAbleToEdit || isEditDisabled}
                                style={{
                                    width: 120,
                                    background: "#FF7400",
                                    color: "white",
                                }} onClick={onClickSubmit}>Submit</Button>
                    </Space>
                </Col>
            </Row>
            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={previewTitle}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </Spin>
    )
}

export default AddressChangeRequestComp;